"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useUniqueId = void 0;
var _react = require("react");
var _lodash = _interopRequireDefault(require("lodash.uniqueid"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
const useUniqueId = () => {
  const [id, setId] = (0, _react.useState)((0, _lodash.default)('server-id-'));
  (0, _react.useLayoutEffect)(() => {
    setId((0, _lodash.default)('id-'));
  }, []);
  return id;
};
exports.useUniqueId = useUniqueId;